import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modalSendAllCardsComponent from './modalSendAllCards.component';

let modalSendAllCardsModule = angular.module('modalSendAllCards', [
  uiRouter
])

.component('modalSendAllCards', modalSendAllCardsComponent)

.name;

export default modalSendAllCardsModule;


// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/modalSendAllCards/modalSendAllCards.js